import { Locales } from '@carsys/enums/locales'
import { getAllCountries } from '@cbgms/api/modules/miscellaneous/countries/requests'
import { AsyncAction } from '@cbgms/base/redux/async-action'

import { GETCountriesResponse } from '@cbgms/api'

const GET_COUNTRIES = 'GET_COUNTRIES'
const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS'
const GET_COUNTRIES_FAILED = 'GET_COUNTRIES_FAILED'

export const getCountries = (locale?: Locales) =>
  AsyncAction<GETCountriesResponse>({
    type: [GET_COUNTRIES, GET_COUNTRIES_SUCCESS, GET_COUNTRIES_FAILED],
    payload: {
      api: 'support',
      request: getAllCountries(locale)
    }
  })
